module.exports = __webpack_public_path__ + "static/media/norwegian_white.4a764ece.svg";